import React from 'react'
import * as styles from './styles.module.scss'

const Author = ({ image, name, date, title }) => (
  <div className={styles.Author}>
    <img src={image.file.url} alt={name} className={styles.Pic} />
    <ul>
      <li className={styles.Name}>{name}</li>
      <li className={styles.Job}>{title}</li>
      <li>{date}</li>
    </ul>
  </div>
)

export default Author
